module.exports = __webpack_public_path__ + "img/login-v2.72cd8a26.svg";